export default __webpack_public_path__ + "static/media/cookies.fa297fdd.jpg";